import React, { useState, useEffect, useRef } from 'react';
import './OfferModal.scss';
import arrow from "../../../../assets/arrow-black.svg"
import { useSelector } from 'react-redux';
import _ from 'lodash';
import { getCurrencyFormat } from '../../../../../../../utilities/helper';

const OfferDropdown = ({ options, placeholder = "Select an option", onSelect, selectedItem, modifier }) => {
    const [selected, setSelected] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const handleSelect = (option) => {
        setSelected(option);
        onSelect(option);
        setIsOpen(false);
    };
    console.log(options)
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const {
        currency,

        selectedOrderType
    } = useSelector((state) => state.resturantData);
    const currencyFormat = getCurrencyFormat(currency);
    const getOptionPriceForCart = (overrides, Id, quantity) => {
        const option = _.find(overrides, { ContextValue: Id });
        const createPriceObj = (price, quantity) => ({
            Amount: price * quantity,
            FormattedText: currencyFormat((price * quantity) / 100),
            FormattedAmount: Number(((price * quantity) / 100).toFixed(2))
        });

        const getPriceData = (price, quantity) => ({
            Delivery: createPriceObj(price?.DeliveryPrice || 0, quantity),
            TakeAway: createPriceObj(price?.PickupPrice || 0, quantity),
            DineIn: createPriceObj(price?.TablePrice || 0, quantity),
            CurrencyCode: currency
        });

        const basePrice = getPriceData(option?.Price || {}, 1);
        const totalPrice = getPriceData(option?.Price || {}, quantity);

        return {
            BaseUnitPrice: basePrice,
            BaseTotalPrice: quantity > 1 ? totalPrice : basePrice
        };
    };
    const getThePriceItem = (overrides, Id, quantity) => {
        let price = getOptionPriceForCart(overrides, Id, quantity).BaseTotalPrice
        let priceValue;
        switch (selectedOrderType) {
            case "delivery":
                priceValue = price.Delivery.FormattedText;
                break;
            case "table":
                priceValue = price.DineIn.FormattedText;
                break;
            case "collection":
                priceValue = price.TakeAway.FormattedText;
                break;
            default:
                priceValue = price.Delivery.FormattedText;
                break;
        }

        return priceValue;
    };
    const getOptionPrice = (overrides, Id, quantity) => {
        let option = _.find(overrides, { ContextValue: Id })
        if (option) {
            return getThePriceItem(overrides, Id, quantity)
        } else {
            return "£0.00"
        }

    }
    return (
        <div className="OfferDropdown" ref={dropdownRef}>
            <div
                className="OfferDropdown-toggle"
                onClick={() => setIsOpen(!isOpen)}
            >
                <span>{selectedItem?.Title?.replace(/\.+$/, '') || selected?.Title?.en?.replace(/\.+$/, '') || selected?.Title?.replace(/\.+$/, '') || placeholder}</span>
                <span className={`arrow ${isOpen ? 'open' : ''}`}><img alt='' src={arrow} /></span>
            </div>

            {isOpen && (
                <ul className="OfferDropdown-menu">
                    {options.map((option) => (
                        <li
                            key={option.MenuItemID}
                            className="OfferDropdown-item"
                            onClick={() => handleSelect(option)}
                        >
                            {option?.Title?.en?.replace(/\.+$/, '') || option?.Title?.replace(/\.+$/, '')}
                            <span> ({getOptionPrice(option.PriceInfo.Overrides, modifier.ModifierGroupID, 1)})</span>

                        </li>
                    ))}
                </ul>
            )
            }
        </div >
    );
};

export default OfferDropdown;
